// Lucide icon: refresh-cw (https://lucide.dev/icons/refresh-cw)
import { RefreshCw } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconReset = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <RefreshCw />
    </IconComponentStyled>
  )
}
